const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/agentic-insights/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { requirePermission } from '@/common/hooks/usePermissions';
import i18n from '@/common/translations/i18n';
import { defaultVariantSearchSchema } from '@/features/agentic-insights/components/experimental/variants/defaultVariant';
type PermissionContext = Parameters<ReturnType<typeof requirePermission>>[0]['context'];
type AgenticInsightsBeforeLoadArgs = {
  context: PermissionContext & {
    flags: {
      tempoAgenticInsightsEnabled: boolean;
    };
  };
  params: {
    loopId: number;
    org: string;
  };
};
export const agenticInsightsBeforeLoad = async (args: AgenticInsightsBeforeLoadArgs) => {
  await requirePermission('view_loop')(args);
  if (!args.context.flags.tempoAgenticInsightsEnabled) {
    throw redirect({
      to: '/org/$org/loop/$loopId/overview',
      params: args.params,
      replace: true
    });
  }
};

/**
 * The nav item's stable address. Classic used to render directly here; it is now one more entry in
 * the variant picker, so this route renders the default variant (Briefing #4) directly in its place —
 * no redirect, since the URL a reader lands on for the nav item has to stay `/agentic-insights`, never
 * an `/experimental/...` address. `DefaultVariantView` is the same component `/experimental/briefing-4`
 * itself renders (`defaultVariant.tsx`), so the two addresses can't drift into two implementations of
 * "the default".
 */
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/agentic-insights/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: agenticInsightsBeforeLoad,
  validateSearch: search => defaultVariantSearchSchema.parse(search),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.agenticInsights.title)
    }
  }
});